import { IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { AffixDrupalApi, DrupalAffixSearch } from "../../../api";
import { useAuth } from "../../../contexts";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { DrupalDataTable } from "../../common";
import { DrupalFieldSet } from "../../common/DurpalFieldSet";

export interface IDrupalAffixListProps {}

export const DrupalAffixList: React.FunctionComponent<IDrupalAffixListProps> = () => {
  const { user } = useAuth();
  const api = useApiService(AffixDrupalApi);
  const { t } = useTl();
  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    availablePageSizes: [15, 20, 25],
    pageSize: 25,
  });
  const { totalCount } = tableState;
  const searchFunction = React.useCallback(
    (sObj?) => {
      const sobj = DrupalAffixSearch.fromJS({
        ...sObj,
        personId: user?.userId,
        hideDead: true,
      });
      return api.baseSearch(sobj);
    },
    [api, user?.userId]
  );

  const { loading } = useSearchApi({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.AttributionDate),
        fieldName: "attributionDate",
      },
    ],
    [t]
  );

  return (
    <DrupalFieldSet title={`${t(ETLCodes.Affix)} (${totalCount})`}>
      <DrupalDataTable tableState={tableState} loading={loading} columns={columns} />
    </DrupalFieldSet>
  );
};
